import {
  iconBird,
  iconCat,
  iconCatWhite,
  iconDog,
  iconDogWhite,
  iconFish,
  iconHamster,
  iconReptile,
} from '@common/_assets/images';
import { PetSpeciesName } from '@common/models/Enums/PetSpeciesName';
import { makeBold } from '@common/utils';
import React from 'react';
import { Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/esm/types';
interface OverLayItemProps {
  placement?: Placement;
  src: string;
  tooltipText?: string;
  width?: number | 'ignore';
  height?: number | 'ignore';
  className?: string;
  onClick?: () => void;
}
export const OverlayItem = ({
  placement = 'bottom',
  src,
  tooltipText,
  width = 40,
  height = 40,
  className = '',
  onClick,
}: OverLayItemProps) => {
  // Fallback to just showing the image if not tooltip text is provided.
  return tooltipText ? (
    <OverlayTrigger
      key={placement}
      placement={placement}
      delay={1000}
      overlay={<Tooltip id={`tooltip-${placement}`}>{tooltipText}</Tooltip>}
    >
      <Image
        className={className}
        width={width}
        height={height}
        alt={tooltipText}
        src={src}
        onClick={onClick}
      />
    </OverlayTrigger>
  ) : (
    <Image
      className={className}
      width={width}
      height={height}
      src={src}
      onClick={onClick}
    />
  );
};

interface OverLayElementProps {
  placement?: Placement;
  tooltipText: string;
  children: any;
  isWideTooltip?: boolean;
}

export const OverlayElement = ({
  placement = 'bottom',
  tooltipText,
  children,
  isWideTooltip = false,
}: OverLayElementProps) => {
  return (
    <OverlayTrigger
      key={placement}
      placement={placement}
      // delay={300} , delay is handled with css in _tooltip.scss this solves an issue with flashing in the top left corner. for overlay triggers.
      overlay={
        <Tooltip
          id={`tooltip-${placement}`}
          className={`${isWideTooltip ? 'max-width-600px' : 'max-width-280px'}`}
        >
          {tooltipText}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

const TransparentTooltipWhite = ({
  tooltipText,
  children,
  location,
}: {
  tooltipText: string;
  children: any;
  location: Placement;
}) => {
  // const placement = 'bottom'
  return (
    <OverlayTrigger
      key={location}
      placement={location}
      // delay={300} , delay is handled with css in _tooltip.scss this solves an issue with flashing in the top left corner. for overlay triggers.
      overlay={
        <Tooltip
          className="transparent-tooltip max-width-280px"
          id={`tooltip-${location}`}
        >
          <div className="rounded px-4 py-3 d-flex flex-column flex-fill shadow bg-white text-dark">
            {tooltipText}
          </div>
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};
export const TableOverlay = ({
  text,
  location = 'bottom',
}: {
  text: string;
  location?: Placement;
}) => {
  // To change to Black tooltip just switch TransparentTooltipWhite to OverlayElement.
  return (
    <TransparentTooltipWhite tooltipText={text} location={location}>
      <div className="text-truncate">{text}</div>
    </TransparentTooltipWhite>
  );
};

export const TableOverlayBold = ({
  text,
  location = 'bottom',
  query,
}: {
  text: string;
  location?: Placement;
  query: string;
}) => {
  // To change to Black tooltip just switch TransparentTooltipWhite to OverlayElement.
  return (
    <TransparentTooltipWhite tooltipText={text} location={location}>
      <div className="text-truncate">{makeBold(text, query)}</div>
    </TransparentTooltipWhite>
  );
};

interface SpeciesTypeImageProps {
  speciesName: string | undefined;
  height?: number;
  width?: number;
  className?: string;
  white?: boolean;
  hideTooltip?: boolean;
}
export const getSpeciesIcon = (
  speciesName: string | undefined,
  white = false,
) => {
  switch (speciesName) {
    case PetSpeciesName.Canine:
      return white ? iconDogWhite : iconDog;
    case PetSpeciesName.Feline:
      return white ? iconCatWhite : iconCat;
    case PetSpeciesName.Fish:
      return white ? undefined : iconFish;
    case PetSpeciesName.Bird:
      return white ? undefined : iconBird;
    case PetSpeciesName.Reptile:
      return white ? undefined : iconReptile;
    case PetSpeciesName.Small_Animal:
      return white ? undefined : iconHamster;
    default:
      return undefined;
  }
};

export const SpeciesTypeImage = ({
  speciesName,
  height = 16,
  width = 16,
  className = '',
  white = false,
  hideTooltip = false,
}: SpeciesTypeImageProps) => {
  if (speciesName) {
    const speciesIcon = getSpeciesIcon(speciesName, white);
    return speciesIcon ? (
      <OverlayItem
        className={`cursor-pointer ${className}`}
        height={height}
        width={width}
        src={speciesIcon}
        tooltipText={hideTooltip ? undefined : speciesName}
      />
    ) : (
      <></>
    );
  } else {
    return <></>;
  }
};
